import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  tag: {
    page: 0,
    size: 10,
    sortby: 'name',
    sortdir: 'ASC',
    s: '',
    withSchema: undefined,
  },
}

const masterItemsSlice = createSlice({
  name: 'masterItems',
  initialState,
  reducers: {
    setFetchOption(state, action) {
      state.tag = {
        ...state.tag,
        ...action.payload,
      }
    },
    resetFetchOption(state) {
      state.tag = initialState.tag
    },
  },
})

export const { setFetchOption, resetFetchOption } = masterItemsSlice.actions

export default masterItemsSlice.reducer
